import { nanoid } from 'nanoid'
import type { IAddConversationNoteCallingActionPayload } from 'entities/AICalling/api/types.ts'
import { type IAddContactNoteActionProps } from 'widgets/TemplateActions/addContactNote/addContactNote.tsx'

export const createAddConversationNoteCallingAction = (
  data: IAddContactNoteActionProps['data'],
  token_id?: string
): IAddConversationNoteCallingActionPayload => {
  return {
    action_type: 'add_conversation_note',
    trigger_type: 'end_of_call',
    settings: {
      token_id: token_id ?? nanoid(),
      auto: data?.auto || false,
      message: data?.message ?? '',
      media_url: data?.media_url || [],
    },
  }
}
